module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_f_erythristic.43d189b2.png";